import { useState } from 'react';
import { FormSelect, FormInput, FormUpload, Button, Modal, OtherDocsUpload } from "../../components";
import { getDateAfterTimeframe, nextMonthStartDate } from '../../utils/constants';
import useConfigOptions from '../../hooks/useConfigOptions';
import LoanAuth from "./LoanAuth";
import { preCheckLoanEligibility } from '../../utils/loanProcessing';
import { Dialog } from '@headlessui/react';
import EligCheck from './EligCheck';
import { useDispatch } from 'react-redux';
import { show } from '../../slices/toastSlice';
import NextOfKin from './NextOfKin';
import { HugeiconsIcon } from '@hugeicons/react';
import { Cancel01Icon } from '@hugeicons/core-free-icons';
import SectionCard from './SectionCard';

function Loanme({ client }) {

    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const {
        sectorOpts, billPaymentOptions, insuranceOpts, purposeOfLoanOpts,
        optionsYN, balanceOpts, numOfYearsWithEmployer, missedPaymentOptions, billsHistoryOpts,
        paymentPlanOpts, paymentDurationOpts, incomeFrequencyOpts, automaticPaymentOpts,
        relationshipManagers,
    } = useConfigOptions();

    const closeModal = () => setIsOpen(false);
    const openModal = () => setIsOpen(true);

    const [employedCurrently, setEmployedCurrently] = useState('');
    const [salaryStatus, setSalaryStatus] = useState("");
    const [incomeStatus, setIncomeStatus] = useState("");
    const [automatedPaymentsStatus, setAutomatedPaymentsStatus] = useState("");
    const [incomeAmt, setIncomeAmt] = useState("");
    const [debtStatus, setDebtStatus] = useState("");
    const [debtAmt, setDebtAmt] = useState(0);
    const [momoBalance, setMomoBalance] = useState("");
    const [employerName, setEmployerName] = useState("");
    const [yearsAtWork, setYearsAtWork] = useState("");
    const [employmentSector, setEmploymentSector] = useState("");
    const [outstandingLoans, setOutstandingLoans] = useState('');
    const [loansTaken, setLoansTaken] = useState('');
    const [loanDefaultStatus, setLoanDefaultStatus] = useState('');
    const [defaultedLoanStatus, setDefaultedLoanStatus] = useState('');
    const [billsOption, setBillsOption] = useState('');
    const [billsHistory, setBillsHistory] = useState('');
    const [billsHistoryStatus, setBillsHistoryStatus] = useState('');
    const [loanPaymentHistory, setLoanPaymentHistory] = useState('');
    const [billPaymentHistory, setBillPaymentHistory] = useState('');
    const [savingHabits, setSavingHabits] = useState('');
    const [savingsFreq1, setSavingsFreq1] = useState('');
    const [savingsFreq2, setSavingsFreq2] = useState('');
    const [savingsFreq3, setSavingsFreq3] = useState('');
    const [typeOfInsurance, setTypeOfInsurance] = useState('');
    const [eligibleSavingsHabit, setEligibleSavingsHabit] = useState('');
    const [amountReq, setAmountReq] = useState('');
    const [purpose, setPurpose] = useState('');
    const [paymentPlan, setPaymentPlan] = useState('');
    const [paymentDuration, setPaymentDuration] = useState('');
    const [repaySource, setRepaySource] = useState('');
    const [freqIncome, setFreqIncome] = useState('');
    const [autoDeduction, setAutoDeduction] = useState('');
    const [startDate, setStartDate] = useState(getDateAfterTimeframe('daily'));
    const [relManager, setRelManager] = useState('');
    const [guarantorFirstName, setGuarantorFirstName] = useState('');
    const [guarantorLastName, setGuarantorLastName] = useState('');
    const [guarantorPhone, setGuarantorPhone] = useState('');
    const [guarantorAddress, setGuarantorAddress] = useState('');
    const [guarantorRelationship, setGuarantorRelationship] = useState('');
    const guarantorIdType = 'GhanaCard';
    const [guarantorIdNumber, setGuarantorIdNumber] = useState('');
    const [guarantorDigitalAddress, setGuarantorDigitalAddress] = useState('');
    const [guarantorDob, setGuarantorDob] = useState('');
    const [nextOfKin, setNextOfKin] = useState('');
    const [nextOfKinPhone, setNextOfKinPhone] = useState('');
    const [nextOfKinAddress, setNextOfKinAddress] = useState('');
    const [nextOfKinRelationship, setNextOfKinRelationship] = useState('');
    const [incomeProof, setIncomeProof] = useState();
    const [bankOrMomoStatement, setBankOrMomoStatement] = useState();
    const [otherDocs, setOtherDocs] = useState([]);
    const signedName = client?.name;
    const [processing, setProcessing] = useState(false);
    const [preCheckData, setPreCheckData] = useState({});

    const handleRequest = async(e) => {
        e.preventDefault();
        setProcessing(true);

        if (!relManager) {
            setProcessing(false);
            dispatch(show({ type: "error", state: true, message: "Please select a relationship manager" }));
            return;
        }

        const incomeFile = document.getElementById("incomeProof");
        const bankFile = document.getElementById("bankOrMomoStatement");

        if(!incomeFile.files.length) {
            setProcessing(false);
            dispatch(show({ type: "error", state: true, message: "Must attach proof of income" }));
            return;
        }

        if(!bankFile.files.length) {
            setProcessing(false);
            dispatch(show({ type: "error", state: true, message: "Must attach bank or momo statement" }));
            return;
        }

        const data = {
            phone: client?.phone, employedCurrently, salaryStatus, incomeStatus, automatedPaymentsStatus,
            incomeAmt, debtAmt, momoBalance, employerName, yearsAtWork, employmentSector,
            outstandingLoans, loansTaken, loanDefaultStatus, defaultedLoanStatus, billsOption,
            billsHistory, billsHistoryStatus, loanPaymentHistory, billPaymentHistory, savingHabits,
            savingsFreq1, savingsFreq2, savingsFreq3, typeOfInsurance, eligibleSavingsHabit,
            amountReq, purpose, paymentPlan, paymentDuration, repaySource, freqIncome, autoDeduction,
            incomeProof, bankOrMomoStatement, otherDocs, startDate, relManager,
            guarantorFirstName, guarantorLastName, guarantorPhone, guarantorAddress,
            guarantorRelationship, guarantorIdType, guarantorIdNumber, guarantorDigitalAddress,
            guarantorDob, nextOfKin, nextOfKinPhone, nextOfKinAddress, nextOfKinRelationship,
            signedName
        };

        const response = await preCheckLoanEligibility("loanme", data);
        setPreCheckData({ ...response, data });

        setTimeout(() => {
            setProcessing(false);
            openModal();
        }, 500);
    };

    return (
        <>
        <form className="space-y-4" encType="multipart/form-data" onSubmit={handleRequest}>

            <SectionCard title="Income Information" subtitle="Details about the client's employment and income">
                <FormSelect label="Employed with current employer for at least 1 year?" name="employedCurrently" id="employedCurrently" content={optionsYN} value={employedCurrently} setValue={setEmployedCurrently} />
                <FormSelect label="Monthly income equal to or greater than GHC 2,000?" name="salaryStatus" id="salaryStatus" content={optionsYN} value={salaryStatus} setValue={setSalaryStatus} />
                <FormSelect label="Receives regular monthly income (employment or other)?" name="incomeStatus" id="incomeStatus" content={optionsYN} value={incomeStatus} setValue={setIncomeStatus} />
                <FormSelect label="Loan payments automated?" name="automatedPaymentsStatus" id="automatedPaymentsStatus" content={optionsYN} value={automatedPaymentsStatus} setValue={setAutomatedPaymentsStatus} />
                <FormInput label="Monthly regular income (GHC)" name="incomeAmt" id="incomeAmt" type="number" value={incomeAmt} setValue={setIncomeAmt} />
                <FormSelect label="Currently paying any loans or hire purchase?" name="debtStatus" id="debtStatus" content={optionsYN} value={debtStatus} setValue={setDebtStatus} required={true} />
                {debtStatus === 'Yes' && (
                    <FormInput label="Total debt amount (GHC)" name="debtAmt" id="debtAmt" type="number" value={debtAmt} setValue={setDebtAmt} />
                )}
                <FormSelect label="Cash balance in savings account?" name="momoBalance" id="momoBalance" content={balanceOpts} value={momoBalance} setValue={setMomoBalance} />
            </SectionCard>

            <SectionCard title="Scoring Information" subtitle="Employment details used in credit scoring">
                <FormInput label="Name of employer" name="employerName" id="employerName" type="text" value={employerName} setValue={setEmployerName} />
                <FormSelect label="Years with current employer" name="yearsAtWork" id="yearsAtWork" content={numOfYearsWithEmployer} value={yearsAtWork} setValue={setYearsAtWork} />
                <FormSelect label="Employment sector" name="employmentSector" id="employmentSector" content={sectorOpts} value={employmentSector} setValue={setEmploymentSector} />
            </SectionCard>

            <SectionCard title="Credit Behaviour" subtitle="Outstanding debts and previous loan history">
                <FormSelect label="Currently have outstanding debts or loans?" name="outstandingLoans" id="outstandingLoans" content={optionsYN} value={outstandingLoans} setValue={setOutstandingLoans} />
                <FormSelect label="Taken a loan from any financial institution?" name="loansTaken" id="loansTaken" content={optionsYN} value={loansTaken} setValue={setLoansTaken} />
                <FormSelect label="Ever defaulted or missed a loan payment?" name="loanDefaultStatus" id="loanDefaultStatus" content={optionsYN} value={loanDefaultStatus} setValue={setLoanDefaultStatus} />
                <FormSelect label="How many times missed loan payment?" name="defaultedLoanStatus" id="defaultedLoanStatus" content={missedPaymentOptions} value={defaultedLoanStatus} setValue={setDefaultedLoanStatus} />
            </SectionCard>

            <SectionCard title="Bills Payment" subtitle="Utility and bills payment history">
                <FormSelect label="Bills responsible for paying?" name="billsOption" id="billsOption" content={billPaymentOptions} value={billsOption} setValue={setBillsOption} />
                <FormSelect label="Length of bills payment history?" name="billsHistory" id="billsHistory" content={billsHistoryOpts} value={billsHistory} setValue={setBillsHistory} />
                <FormSelect label="How many times missed bills payment?" name="billsHistoryStatus" id="billsHistoryStatus" content={missedPaymentOptions} value={billsHistoryStatus} setValue={setBillsHistoryStatus} />
                <FormSelect label="3 recent months loan payment history?" name="loanPaymentHistory" id="loanPaymentHistory" content={optionsYN} value={loanPaymentHistory} setValue={setLoanPaymentHistory} />
                <FormSelect label="3 recent months bills payment history?" name="billPaymentHistory" id="billPaymentHistory" content={optionsYN} value={billPaymentHistory} setValue={setBillPaymentHistory} />
            </SectionCard>

            <SectionCard title="Savings Habit" subtitle="Savings behaviour and insurance coverage">
                <div className="col-span-full">
                    <FormSelect label="Savings account held with a financial institution for emergencies?" name="savingHabits" id="savingHabits" content={optionsYN} value={savingHabits} setValue={setSavingHabits} />
                </div>
                <FormInput label="Savings — Month 1 (GHC)" name="savingsFreq1" id="savingsFreq1" type="number" value={savingsFreq1} setValue={setSavingsFreq1} />
                <FormInput label="Savings — Month 2 (GHC)" name="savingsFreq2" id="savingsFreq2" type="number" value={savingsFreq2} setValue={setSavingsFreq2} />
                <FormInput label="Savings — Month 3 (GHC)" name="savingsFreq3" id="savingsFreq3" type="number" value={savingsFreq3} setValue={setSavingsFreq3} />
                <FormSelect label="Insurance coverage type?" name="typeOfInsurance" id="typeOfInsurance" content={insuranceOpts} value={typeOfInsurance} setValue={setTypeOfInsurance} />
                <div className="col-span-full md:col-span-2">
                    <FormSelect label="Regularly save minimum 5% of monthly income?" name="eligibleSavingsHabit" id="eligibleSavingsHabit" content={optionsYN} value={eligibleSavingsHabit} setValue={setEligibleSavingsHabit} />
                </div>
            </SectionCard>

            <SectionCard title="Loan Information" subtitle="Loan amount, purpose, and repayment preferences">
                <FormInput label="Loan amount requested (GHC)" name="amountReq" id="amountReq" type="number" value={amountReq} setValue={setAmountReq} />
                <FormSelect label="Purpose of loan" name="purpose" id="purpose" content={purposeOfLoanOpts} value={purpose} setValue={setPurpose} />
                <FormSelect label="Desired payment plan" name="paymentPlan" id="paymentPlan" content={paymentPlanOpts} value={paymentPlan} setValue={setPaymentPlan} />
                <FormSelect label="Desired payment duration" name="paymentDuration" id="paymentDuration" content={paymentDurationOpts} value={paymentDuration} setValue={setPaymentDuration} />
                <FormInput label="Source of income for repayment" name="repaySource" id="repaySource" type="text" value={repaySource} setValue={setRepaySource} />
                <FormSelect label="Frequency of income" name="freqIncome" id="freqIncome" content={incomeFrequencyOpts} value={freqIncome} setValue={setFreqIncome} />
                <FormSelect label="Preferred automatic repayment method" name="autoDeduction" id="autoDeduction" content={automaticPaymentOpts} value={autoDeduction} setValue={setAutoDeduction} />
                <div>
                    <label htmlFor="startDate" className="form-label">Loan start date</label>
                    <input
                        type="date"
                        name="startDate"
                        id="startDate"
                        className="form-input"
                        value={startDate}
                        onChange={e => setStartDate(e.target.value)}
                        min={new Date().toISOString().split('T')[0]}
                        max={nextMonthStartDate()}
                    />
                </div>
                <FormSelect label="Relationship manager" name="relManager" id="relManager" content={relationshipManagers} value={relManager} setValue={setRelManager} />
            </SectionCard>

            <SectionCard title="Guarantor Information" subtitle="Details of the loan guarantor">
                <FormInput label="First name" name="guarantorFirstName" id="guarantorFirstName" type="text" value={guarantorFirstName} setValue={setGuarantorFirstName} />
                <FormInput label="Last name" name="guarantorLastName" id="guarantorLastName" type="text" value={guarantorLastName} setValue={setGuarantorLastName} />
                <FormInput label="Phone number" name="guarantorPhone" id="guarantorPhone" type="text" value={guarantorPhone} setValue={setGuarantorPhone} />
                <FormInput label="Home address" name="guarantorAddress" id="guarantorAddress" type="text" value={guarantorAddress} setValue={setGuarantorAddress} />
                <FormInput label="Relationship to guarantor" name="guarantorRelationship" id="guarantorRelationship" type="text" value={guarantorRelationship} setValue={setGuarantorRelationship} />
                <FormInput label="GhanaCard number" name="guarantorIdNumber" id="guarantorIdNumber" type="text" value={guarantorIdNumber} setValue={setGuarantorIdNumber} />
                <FormInput label="Digital address" name="guarantorDigitalAddress" id="guarantorDigitalAddress" type="text" value={guarantorDigitalAddress} setValue={setGuarantorDigitalAddress} />
                <div>
                    <label htmlFor="guarantorDob" className="form-label">Date of birth</label>
                    <input
                        type="date"
                        name="guarantorDob"
                        id="guarantorDob"
                        className="form-input"
                        value={guarantorDob}
                        onChange={e => setGuarantorDob(e.target.value)}
                        min="1930-01-01"
                        max={new Date().toISOString().split('T')[0]}
                    />
                </div>
            </SectionCard>

            <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm p-5 space-y-4">
                <div>
                    <p className="text-sm font-semibold text-gray-700 dark:text-gray-200">Next of Kin</p>
                    <p className="text-xs text-gray-400 mt-0.5">Emergency contact information</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <NextOfKin
                        nextOfKin={nextOfKin}
                        setNextOfKin={setNextOfKin}
                        nextOfKinPhone={nextOfKinPhone}
                        setNextOfKinPhone={setNextOfKinPhone}
                        nextOfKinAddress={nextOfKinAddress}
                        setNextOfKinAddress={setNextOfKinAddress}
                        nextOfKinRelationship={nextOfKinRelationship}
                        setNextOfKinRelationship={setNextOfKinRelationship}
                    />
                </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm p-5 space-y-4">
                <div>
                    <p className="text-sm font-semibold text-gray-700 dark:text-gray-200">Supporting Documents</p>
                    <p className="text-xs text-gray-400 mt-0.5">Upload required files — PNG, JPG, PDF, DOC up to 10MB each</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <FormUpload label="Proof of income" name="incomeProof" id="incomeProof" setValue={setIncomeProof} />
                    <FormUpload label="Bank or MoMo statement" name="bankOrMomoStatement" id="bankOrMomoStatement" setValue={setBankOrMomoStatement} />
                    <OtherDocsUpload setValue={setOtherDocs} />
                </div>
            </div>

            <LoanAuth />

            <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm p-5">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <FormInput label="Signed Name" name="signedName" id="signedName" type="text" value={signedName} disabled={true} />
                </div>
            </div>

            <div className="flex justify-end">
                <Button
                    btnText="Check eligibility"
                    btnType="submit"
                    btnClasses="form-button w-auto px-8"
                    processing={processing}
                />
            </div>

        </form>

        <Modal isOpen={isOpen} closeModal={closeModal}>
            <Dialog.Panel className="w-full max-w-md md:max-w-2xl transform overflow-hidden rounded-2xl bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-xl transition-all">
                <div className="flex items-center justify-between mb-5">
                    <div className="flex items-center gap-3">
                        <p className="text-base font-semibold text-gray-900 dark:text-gray-50">Pre-Check Result</p>
                        <span className={`px-2.5 py-1 text-xs font-medium rounded-full capitalize ${
                            preCheckData?.status === 'accepted'
                                ? 'bg-emerald-100 text-emerald-700'
                                : 'bg-red-100 text-red-600'
                        }`}>
                            {preCheckData?.status}
                        </span>
                    </div>
                    <button type="button" onClick={closeModal} className="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                        <HugeiconsIcon icon={Cancel01Icon} size={16} />
                    </button>
                </div>
                <EligCheck
                    status={preCheckData?.status}
                    data={preCheckData}
                    loanType="loanme"
                    closeModal={closeModal}
                />
            </Dialog.Panel>
        </Modal>

        </>
    );
}

export default Loanme;
